import { useInfiniteQuery, useMutation } from 'react-query';
import {
  FinancialConsultPayableListRequest,
  FinancialConsultReceivableListRequest,
} from './consultation.types';
import consultationServices from './consultation.services';
import notificationError from '@/utils/functions/notificationError';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import { notification } from 'antd';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';

export const FINANCIAL_CONSULT_PAYABLE_LIST =
  'consult-installment-payable-list';

export const FINANCIAL_CONSULT_RECEIVABLE_LIST =
  'consult-installment-receivable-list';

export function useFinancialConsultationPayableList(
  params?: FinancialConsultPayableListRequest,
  enabled = true,
) {
  return useInfiniteQuery({
    queryKey: [FINANCIAL_CONSULT_PAYABLE_LIST, { ...params }],
    queryFn: ({ pageParam }) =>
      consultationServices.payableList({
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
        nextToken: pageParam,
      }),
    enabled: enabled,
    getNextPageParam: (lastPage) => lastPage.nextToken,
    onError(error) {
      notificationError(error);
    },
  });
}

export function useFinancialConsultationReceivableList(
  params?: FinancialConsultReceivableListRequest,
  enabled = true,
) {
  return useInfiniteQuery({
    queryKey: [FINANCIAL_CONSULT_RECEIVABLE_LIST, { ...params }],
    queryFn: ({ pageParam }) =>
      consultationServices.receivableList({
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
        nextToken: pageParam,
      }),
    enabled: enabled,
    getNextPageParam: (lastPage) => lastPage.nextToken,
    onError(error) {
      notificationError(error);
    },
  });
}

export function useFinancialConsultationPayableBind() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: consultationServices.payableBind,
    onSuccess() {
      notification.success({
        message: 'Parcela migrada vinculada com sucesso',
      });
      queryChanel({ invalidateQueries: [FINANCIAL_CONSULT_PAYABLE_LIST] });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useFinancialConsultationReceivableBind() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: consultationServices.receivableBind,
    onSuccess() {
      notification.success({
        message: 'Parcela migrada vinculada com sucesso',
      });
      queryChanel({ invalidateQueries: [FINANCIAL_CONSULT_RECEIVABLE_LIST] });
    },
    onError(error) {
      notificationError(error);
    },
  });
}
